<template src="./new_latest.html"></template>

<script>
import NewsService from 'Services/NewsService';

export default {
  data() {
    return {
      arrnews: [],
      slide: 0,
      sliding: null,
      i18n: 2,
    };
  },

  created() {
    this.listNewsLatest();
  },

  methods: {
    convertHTML(value) {
      if (value) {
        if (value.length < 300) {
          return `${value.replace(/(<([^>]+)>)/g, '')}`;
        }
        return `${value.replace(/(<([^>]+)>)/g, '').substring(0, 300)}...`;
      }

      return '';
    },
    listNewsLatest() {
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }

      const params = {
        i18n: this.i18n,
      };

      NewsService.listLatestClient(params)
        .then((response) => {
          this.arrnews = response.data;
        })
        .catch(() => {
        });
    },
  },
};
</script>
